import { render, staticRenderFns } from "./RoutingStatus.vue?vue&type=template&id=656f492a&scoped=true&"
import script from "./RoutingStatus.vue?vue&type=script&lang=js&"
export * from "./RoutingStatus.vue?vue&type=script&lang=js&"
import style0 from "./RoutingStatus.vue?vue&type=style&index=0&id=656f492a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "656f492a",
  null
  
)

export default component.exports